import { render, staticRenderFns } from "./File.vue?vue&type=template&id=1c9e74f0&"
import script from "./File.vue?vue&type=script&lang=ts&"
export * from "./File.vue?vue&type=script&lang=ts&"
import style0 from "./File.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DownloadableFile: require('/tmp/build_4600e676/src/components/media/DownloadableFile.vue').default,BlockContentOneColumn: require('/tmp/build_4600e676/src/components/block/ContentOneColumn.vue').default})
